module.exports = __webpack_public_path__ + "static/brainstorm@2x-3c78ca9898fbb7b20be9e557d75be293.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/enterprise/brainstorm@2x.png
// module id = 2563
// module chunks = 168707334958949